export const LIVE_DEVICE_REQUEST = 'LIVE_DEVICE_REQUEST';
export const LIVE_DEVICE_SUCCESS = 'LIVE_DEVICE_SUCCESS';

export const LIVE_CAPTURE_INPUTS_REFRESH_REQUEST = 'LIVE_CAPTURE_INPUTS_REFRESH_REQUEST';
export const LIVE_CAPTURE_INPUTS_REFRESH_SUCCESS = 'LIVE_CAPTURE_INPUTS_REFRESH_SUCCESS';

export const LIVE_START_REQUEST = 'LIVE_START_REQUEST';

export const LIVE_STOP_REQUEST = 'LIVE_STOP_REQUEST';
export const LIVE_STOP_SUCCESS = 'LIVE_STOP_SUCCESS';

export const LIVE_SESSION_SELECTED_CAPTURE_INPUTS_UPDATE = 'LIVE_SESSION_SELECTED_CAPTURE_INPUTS_UPDATE';
export const DISPOSE_LIVE_SESSION_DETAIL_STORE = 'DISPOSE_LIVE_SESSION_DETAIL_STORE';

export const PTZ_PRESET_REQUEST = 'PTZ_PRESET_REQUEST';
export const PTZ_PRESET_SUCCESS = 'PTZ_PRESET_SUCCESS';
export const PTZ_LOCATION_REQUEST = 'PTZ_LOCATION_REQUEST';
export const PTZ_LOCATION_SUCCESS = 'PTZ_LOCATION_SUCCESS';
export const PTZ_CONTINUOUS_REQUEST = 'PTZ_CONTINUOUS_REQUEST';
export const PTZ_CONTINUOUS_SUCCESS = 'PTZ_CONTINUOUS_SUCCESS';
export const PTZ_ABSOLUTE_REQUEST = 'PTZ_ABSOLUTE_REQUEST';
export const PTZ_ABSOLUTE_SUCCESS = 'PTZ_ABSOLUTE_SUCCESS';

export const VALIDATE_SIMULATOR_REQUEST = 'VALIDATE_SIMULATOR_REQUEST';
export const VALIDATE_SIMULATOR_SUCCESS = 'VALIDATE_SIMULATOR_SUCCESS';

export const LIVE_SESSION_UPDATE_TITLE = 'LIVE_SESSION_UPDATE_TITLE';

export const LIVE_SESSION_UPDATE_SELECTED_PEERS = 'LIVE_SESSION_UPDATE_SELECTED_PEERS';
